import React, { useEffect, createElement } from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { BonusSection } from './components/BonusSection';
import { PackComposite } from './components/PackComposite';
import { UrgencySection } from './components/UrgencySection';
import { ProductOffer } from './components/ProductOffer';
import { Testimonials } from './components/Testimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel manually
    const PIXEL_ID = '1322033292727002';
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args);
        } else {
          n.queue.push(args);
        }
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      // Load the Facebook Pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      // Initialize and track pageview
      ;
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-[#FFF8F0] text-[#3C1518] font-sans selection:bg-[#EA580C] selection:text-white" data-id="element-0">
      <StickyTopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <EmotionalTransition data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <WhatIsIncluded data-id="element-8" />
        <BonusSection data-id="element-9" />
        <PackComposite data-id="element-10" />
        <UrgencySection data-id="element-11" />
        <ProductOffer data-id="element-12" />
        <Testimonials data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQSection data-id="element-15" />
      </main>

      <footer className="bg-[#F5E6D3] py-8 text-center text-[#A8763E] text-sm border-t border-[#E8D5C0]" data-id="element-16">
        <div className="max-w-4xl mx-auto px-4" data-id="element-17">
          <p className="mb-4" data-id="element-18">
            Tocá el botón de abajo y obtené acceso inmediato al recetario
            completo junto con todos los bonos incluidos.
            <br data-id="element-19" />
            Empezá hoy mismo a preparar tortas caseras que siempre salen bien.
          </p>
          <a href="http://checkout.sabores365.online/cart/59169685471313:1" className="inline-block py-3 px-6 bg-[#EA580C] text-white font-bold rounded-lg hover:bg-[#C2410C] transition-colors mb-8" data-id="element-20">
            ¡QUIERO MI RECETARIO AHORA!
          </a>
          <p data-id="element-21">
            © {new Date().getFullYear()} Sabores 365. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <PurchasePopup data-id="element-22" />
    </div>;
}